'use strict';

document.addEventListener("DOMContentLoaded", () => {
    const newsCategories = document.querySelector(".news-categories");
    const articlesContainer = document.querySelector(".articles-container");

    if (newsCategories) {
        newsCategories.addEventListener("click", (e) => {
            if (e.target && e.target.matches(".news-category")) {
                e.preventDefault();
                document.querySelectorAll(".news-categories .news-category").forEach(cat => {
                    cat.classList.remove("underline", "font-weight-bold");
                });
                e.target.classList.add("underline", "font-weight-bold");
                const url = e.target.getAttribute("data-category-url");
                fetch(url)
                    .then(response => response.text())
                    .then(data => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data, "text/html");
                        const newContent = doc.querySelector(".articles-container").innerHTML;
                        articlesContainer.innerHTML = newContent;
                    })
                    .catch(err => {
                        location.reload();
                    });
            }
        });
    }

    // Use event delegation on a parent element that will not be removed
    if (articlesContainer) {
        articlesContainer.addEventListener("click", (e) => {
            if (e.target && e.target.matches(".js-blog-load-more-btn")) {
                e.preventDefault();
                const url = e.target.getAttribute("data-loadmore-url");
                e.target.parentElement.remove();
                fetch(url)
                    .then(response => response.text())
                    .then(data => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data, "text/html");
                        const newContent = doc.querySelector(".articles-container").innerHTML;
                        articlesContainer.insertAdjacentHTML("beforeend", newContent);
                    })
                    .catch(err => {
                        location.reload();
                    });
            }
        });
    }
});
